import { useState, useEffect } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import ThemeToggle from '../ThemeToggle/ThemeToggle';
import { throttle } from '../../utils/performance';
import './Navbar.scss'

const sections = ['home', 'about', 'work', 'systems', 'skills', 'Testimonials', 'contact'];

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + window.innerHeight * 0.3;

      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.offsetTop <= scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    const throttledScroll = throttle(handleScroll, 100);

    window.addEventListener('scroll', throttledScroll, { passive: true });
    handleScroll(); // set initial state
    return () => window.removeEventListener('scroll', throttledScroll);
  }, []);

  return (
    <nav className='app__navbar'>
      <a href="#home" className='app__navbar-logo' aria-label="Home">
        <span className="logo-monogram">PG</span>
      </a>
      <ul className="app__navbar-links">
        {sections.map((item) => (
          <li className={`app__flex p-text ${activeSection === item ? 'app__navbar-link--active' : ''}`} key={`link-${item}`}>
            <div />
            <a className="bold-text" href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <ThemeToggle />
      <div className='app__navbar-menu'>
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {
          toggle && (
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: 'easeOut'}}
            >
              <HiX onClick={() => setToggle(false)} />
              <ul>
                {sections.map((item) => (
                  <li key={item} className={activeSection === item ? 'app__navbar-link--active' : ''}>
                    <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                  </li>
                ))}
              </ul>
            </motion.div>
          )
        }
      </div>
    </nav>
  )
}

export default Navbar